import React from 'react';
import TablaVotosPartidos_Cabecera from './TablaVotosPartidos_Cabecera';
import TablaVotosPartidos_FilaPartido from './TablaVotosPartidos_FilaPartido';
import { usePage } from '../../contexts/pageContext';
import useIni from '../../hooks/useIni';
import visibilidadCamara from '../utils/VisibilidadComponentes';

const TablaVotosPartidos = ({data:camara}) => {

  const ini = useIni();
  const pageState = usePage();
  const { data } = pageState;
  const {mostrarCandidatos, mostrarCargos, mostrarSoloCandidatosConCargo} = visibilidadCamara(camara.cam, ini, data);

  return (
    <table>
      <TablaVotosPartidos_Cabecera mostrarCargos={mostrarCargos}/>
      <tbody>
      {camara.partotabla.map(partido => {
          // return(<TablaVotosPartidos_FilaPartido partido={partido} camaraID={camara.cam}/>)
          return(<TablaVotosPartidos_FilaPartido partido={partido} eleccion={data.elec}
                                                 mostrarCandidatos={mostrarCandidatos}
                                                 mostrarCargos={mostrarCargos}
                                                 mostrarSoloCandidatosConCargo={mostrarSoloCandidatosConCargo}/>)
      })}
      </tbody>
    </table>
  );
};

export default TablaVotosPartidos;
